import React, { useEffect, useState } from 'react'
import { Formik, Form, Field, ErrorMessage, useFormikContext } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { useMutation } from '@apollo/client'
import { CREATE_TICKET } from '../../../graphql/mutation'
import { GET_TOTAL_NUMBER_OF_TICKET } from '../../../graphql/query'
import { Loader } from 'react-bootstrap-typeahead'
import { v4 as uuidv4 } from 'uuid'

interface IProps {
  closeModal: any
  refetch: any
}

interface FormData {
  subject: string
  priorityId: number
  description: string
  statusId: number
  categoryTypeId: number
}

const initialValues: FormData = {
  subject: '',
  priorityId: 1,
  statusId: 1,
  description: '',
  categoryTypeId: 1
}

const validationSchema = Yup.object({
  subject: Yup.string().required('Required'),
  priorityId: Yup.number().required('Required'),
  statusId: Yup.number().required('Required'),
  description: Yup.string().required('Required'),
  categoryTypeId: Yup.number().required('Required')
})

const CreateTicketAdmin: React.FC<IProps> = ({ closeModal, refetch }) => {
  const [selectPriority, setSelectPriority] = useState<any>(0)
  const [selectCategory, setSelectCategory] = useState<any>(0)

  const priorityOption = [
    { name: 'High', value: 1 },
    { name: 'Low', value: 2 },
    { name: 'Medium', value: 3 }
  ]

  const categoryOption = [
    { name: 'Support', value: 1 },
    { name: 'Development', value: 2 },
    { name: 'Service', value: 3 }
  ]

  const [createTicket, { loading: mutationLoading }] = useMutation(CREATE_TICKET, {
    refetchQueries: [
      {
        query: GET_TOTAL_NUMBER_OF_TICKET,
        context: {
          headers: {
            'access-control-allow-methods': 'Admin-Tickets'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'Admin-Tickets'
      }
    }
  })

  const handlePriority = (e: any) => {
    setSelectPriority(e.target.value)
  }

  const handleCategory = (e: any) => {
    setSelectCategory(e.target.value)
  }

  const handleSubmit = async (values: FormData, formikBag: any) => {
    try {
      const formDataWithStatus = {
        ...values,
        statusId: 1,
        priorityId: +selectPriority,
        categoryTypeId: +selectCategory
      }

      const { data } = await createTicket({
        variables: {
          input: formDataWithStatus
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Admin-Tickets'
          }
        }
      })

      // Reset form
      formikBag.resetForm()
      closeModal()
      toast.success(data?.createTicket?.message)
      await refetch()
    } catch (error) {
      console.error('Error creating ticket:', error)
    }
  }

  const ClearButton = () => {
    const { resetForm } = useFormikContext<FormData>()
    const handleClearForm = () => {
      resetForm()
      setSelectCategory(0)
      setSelectPriority(0)
    }

    return (
      <button type='button' className='btn btn-secondary' onClick={handleClearForm}>
        Clear
      </button>
    )
  }

  console.log(selectCategory, 'SelectCategory')

  return (
    <div className='container' style={{ padding: '0px', marginTop: '20px' }}>
      {/* <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}
      >
        <h2 style={{ padding: '10px', marginBottom: '0px', paddingLeft: '0px' }}>
          Register a Query
        </h2>
        <button
          type='button'
          className='btn-close'
          aria-label='Close'
          onClick={closeModal}
        ></button>
      </div> */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div
            className='form-group'
            style={{ display: 'flex', width: '100%', alignItems: 'center' }}
          >
            <label
              htmlFor='subject'
              style={{ fontSize: '15px', fontWeight: '700', color: '#4b4b4b', width: '20%' }}
            >
              Title
            </label>
            <div style={{ width: '80%' }}>
              <Field type='text' className='form-control' id='subject' name='subject' />
              <ErrorMessage name='subject' component='div' className='text-danger' />
            </div>
          </div>
          <div
            className='form-group'
            style={{ display: 'flex', alignItems: 'center', width: '100%' }}
          >
            <label
              htmlFor='categoryTypeId'
              style={{ fontSize: '14px', fontWeight: '700', color: '#4b4b4b', width: '20%' }}
            >
              Category
            </label>
            <select
              required
              className='form-select form-select-solid form-select'
              onChange={handleCategory}
              style={{
                width: '80%'
              }}
            >
              {selectCategory === 0 && (
                <option value='' selected disabled>
                  Choose Category
                </option>
              )}
              {categoryOption &&
                categoryOption?.map((categoryName, index) => (
                  <option key={uuidv4()} value={categoryName?.value} style={{ border: 'none' }}>
                    {categoryName?.name}
                  </option>
                ))}
            </select>
          </div>

          <div
            className='form-group'
            style={{ display: 'flex', alignItems: 'center', width: '100%' }}
          >
            <label
              htmlFor='categoryTypeId'
              style={{ fontSize: '14px', fontWeight: '700', color: '#4b4b4b', width: '20%' }}
            >
              Status
            </label>
            <select
              required
              className='form-control form-control-solid'
              // onChange={handleStatusSelect}
              style={{
                width: '80%'
              }}
              disabled
            >
              <option>Open</option>
            </select>
          </div>

          <div
            className='form-group'
            style={{ display: 'flex', alignItems: 'center', width: '100%' }}
          >
            <label
              htmlFor='priority'
              style={{ fontSize: '14px', fontWeight: '700', color: '#4b4b4b', width: '20%' }}
            >
              Priority
            </label>
            <select
              required
              className='form-select form-select-solid form-select'
              onChange={handlePriority}
              style={{
                width: '80%'
              }}
            >
              {selectPriority === 0 && (
                <option value='' disabled selected>
                  Choose Priority
                </option>
              )}
              {priorityOption &&
                priorityOption?.map((option, index) => (
                  <option key={uuidv4()} value={option?.value}>
                    {option.name}
                  </option>
                ))}
            </select>
          </div>

          <div
            className='form-group'
            style={{ display: 'flex', alignItems: 'center', width: '100%' }}
          >
            <label
              htmlFor='description'
              style={{ fontSize: '15px', fontWeight: '700', color: '#4b4b4b', width: '20%' }}
            >
              Query
            </label>
            <div style={{ width: '80%' }}>
              <Field as='textarea' className='form-control' id='description' name='description' />
              <ErrorMessage name='description' component='div' className='text-danger' />
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              gap: '20px',
              marginTop: '20px',
              width: '100%',
              justifyContent: 'end'
            }}
          >
            <ClearButton />
            <button type='submit' className='btn btn-primary'>
              {mutationLoading ? (
                <div>
                  {' '}
                  Creating <Loader />
                </div>
              ) : (
                'Create'
              )}
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  )
}

export default CreateTicketAdmin
